module.exports = __webpack_public_path__ + "static/media/ig.644865d6.png";